'use client';

import {
    CaptionProps,
    DayPickerDefaultProps,
    DayPickerMultipleProps,
    DayPickerProps,
    DayPickerRangeProps,
    DayPicker as ReactDayPicker,
    useNavigation,
} from 'react-day-picker';
import { format } from 'date-fns';
import { IconButton } from '../../Buttons/IconButton';
import { ArrowLeftIcon } from '../../Icons/ArrowLeftIcon';
import 'react-day-picker/dist/style.css';

const CustomCaption = ({ displayMonth, isLoading }: CaptionProps & { isLoading?: boolean }) => {
    const { goToMonth, nextMonth, previousMonth } = useNavigation();

    return (
        <div className="mb-[30px] mt-[6px] flex w-full items-center justify-between">
            <IconButton
                icon={
                    <ArrowLeftIcon
                        className={`h-4 w-4 ${
                            !isLoading && previousMonth
                                ? '[&_path]:fill-gray-1 [&_path]:dark:fill-brand'
                                : '[&_path]:fill-gray-3 [&_path]:dark:fill-gray-3'
                        }`}
                    />
                }
                className="h-9 w-9 rounded-[36px] border border-ash bg-ash shadow-none hover:bg-white hover:shadow-lightCard disabled:cursor-default disabled:bg-ash disabled:shadow-none dark:border-none dark:bg-dark-2 dark:hover:bg-dark-3 dark:hover:shadow-dark disabled:dark:bg-dark-2 disabled:dark:shadow-none"
                disabled={isLoading || !previousMonth}
                onClick={() => previousMonth && goToMonth(previousMonth)}
                title="prev-month"
            />
            <div className="tx-heading-4 text-center text-gray-2 dark:text-white">
                {format(displayMonth, 'MMMM yyyy')}
            </div>
            <IconButton
                icon={
                    <ArrowLeftIcon
                        className={`h-4 w-4 ${
                            !isLoading && nextMonth
                                ? '[&_path]:fill-gray-1 [&_path]:dark:fill-brand'
                                : '[&_path]:fill-gray-3 [&_path]:dark:fill-gray-3'
                        }`}
                    />
                }
                className="h-9 w-9 rotate-180 rounded-[36px] border border-ash bg-ash shadow-none hover:bg-white hover:shadow-lightCard disabled:cursor-default disabled:bg-ash disabled:shadow-none dark:border-none dark:bg-dark-2 dark:hover:bg-dark-3 dark:hover:shadow-dark disabled:dark:bg-dark-2 disabled:dark:shadow-none"
                disabled={isLoading || !nextMonth}
                onClick={() => nextMonth && goToMonth(nextMonth)}
                title="next-month"
            />
        </div>
    );
};

type TDayPickerProps =
    | DayPickerDefaultProps
    | DayPickerProps
    | DayPickerMultipleProps
    | DayPickerRangeProps;

export const DayPicker = ({
    isLoading,
    ...reactDayPickerProps
}: TDayPickerProps & { isLoading?: boolean }) => (
    <div
        className="day-picker-container flex w-full cursor-default justify-center"
        data-test-id="calendar-daypicker"
    >
        <ReactDayPicker
            components={{ Caption: (props) => CustomCaption({ ...props, isLoading }) }}
            {...reactDayPickerProps}
        />
    </div>
);
